import React from "react";
import { MenuMessageService } from './message-service';

/**
 * BaseMenu implementing close logic for dropdowns:
 * - close other menus when opening current menu
 * - using observer pattern: https://en.wikipedia.org/wiki/Observer_pattern
 * 
 * The problem is described here:
 * https://stackoverflow.com/questions/54549294/reactjs-dropdown-menu-close-other-menus-before-opening-current
 */
export class BaseMenu extends React.Component {
  constructor(props, menuName) {
    super(props);
    this.status = {
      show: false,
      menuName: menuName
    };
    this.toggleShow = this.toggleShow.bind(this);
    this.showMenu = this.showMenu.bind(this);
    this.hideMenu = this.hideMenu.bind(this);
  }

  componentDidMount() {
    this.subscription = MenuMessageService.getMessageChangeMessage().subscribe(menuChange => {
        // hiding menu if menuName is not current menu
        if (menuChange.isOpened && menuChange.menuName !== this.status.menuName) {
          this.status.show = false;
          this.setState(this.status);
        }
    });
  }

  componentWillUnmount() {
      this.subscription.unsubscribe();
  }

  hideMenu(event) {
    this.setShowState(false);
  }

  showMenu(event) {
    this.setShowState(true);
  }

  toggleShow(event) {
    this.setShowState(!this.status.show);
  }

  setShowState(isVisible) {
    this.status.show = isVisible;
    this.setState(this.status);
    MenuMessageService.sendMenuChangeMessage(this.status.menuName, this.status.show);
  }
}